import { Box, SxProps, Typography } from "@outschool/backpack";
import { OSSubscriptions } from "@outschool/business-rules";
import { ClassDetailsQuery_ActivityFragment } from "@outschool/gql-frontend-generated";
import { useLocalPriceDisplay, useTranslation } from "@outschool/localization";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

// NOTE: Keep this in sync with PriceCreditsLineItem
const EstimatedValueLineItem = ({
  activity,
  sx,
}: {
  activity: Pick<
    ClassDetailsQuery_ActivityFragment,
    | "hasTeacherSchedule"
    | "priceCredits"
    | "isOneTime"
    | "isClub"
    | "isSelfPaced"
    | "duration_weeks"
    | "perWeeklyCourseCredits"
    | "is_ongoing_weekly"
    | "weekly_meetings"
    | "allows_recurring_payment"
  >;
  sx?: SxProps;
}) => {
  const { t } = useTranslation(
    "client\\components\\detailPage\\mainBody\\desktopActivityCards\\EstimatedValueLineItem",
  );

  const { renderCurrencyString } = useLocalPriceDisplay();
  const isMobile = useIsMobile();

  // Not necessarily by week, but with that is shown as the top level display inside PriceCreditsLineItem
  let credits: number | null = null;
  let weeklyFlag: string | null = null;
  if (activity.hasTeacherSchedule) {
    credits = activity.priceCredits;
  } else if (activity.isOneTime) {
    credits = activity.priceCredits;
  } else if (activity.isClub) {
    credits = activity.priceCredits;
  } else if (activity.isSelfPaced && activity.duration_weeks) {
    credits = activity.perWeeklyCourseCredits ?? activity.priceCredits;
  } else if (activity.is_ongoing_weekly) {
    if (activity.weekly_meetings === 1) {
      credits = activity.priceCredits;
    } else if ((activity.weekly_meetings || 0) > 1) {
      credits = activity.priceCredits;
      weeklyFlag = "weekly";
    }
  } else if (!activity.allows_recurring_payment) {
    credits = activity.priceCredits;
  } else if (
    activity.allows_recurring_payment &&
    activity.duration_weeks &&
    activity.perWeeklyCourseCredits
  ) {
    credits = activity.perWeeklyCourseCredits;
  }

  const dollarEstimate = OSSubscriptions.creditsToPriceCents(credits ?? 0);
  const dollarEstimateString = renderCurrencyString({
    priceInCents: dollarEstimate ?? 0,
    showCurrencyCode: false,
  });

  if (!dollarEstimate) {
    return null;
  }

  return (
    <Box sx={{ marginLeft: 28, ...sx }}>
      <Typography
        variant={isMobile ? "body2" : "body1"}
        sx={{ color: "text.secondary" }}
      >
        {t("({{dollarEstimateString}} value)", {
          dollarEstimateString,
        })}{" "}
        {weeklyFlag ? "weekly" : ""}
      </Typography>
    </Box>
  );
};

export default EstimatedValueLineItem;
